import React from 'react';

import {
  Accordion,
  AccordionItem,
  AccordionProps as OriginalAccordionProps,
  AccordionItemProps as OriginalAccordionItemProps,
} from '@szhsin/react-accordion';
import cx from 'classnames';

import ArrowDown from 'components/shared/Icon/icons/ArrowDown';

import Text from '../Typography/Text';
import s from './FormAccordion.module.css';

type AccordionProps = OriginalAccordionProps;
type AccordionItemProps = OriginalAccordionItemProps & {
  header: React.ReactNode;
  isRequired?: boolean;
};

export const FormAccordion = (props: AccordionProps) => {
  const { children, ...rest } = props;
  return (
    <Accordion allowMultiple transition transitionTimeout={250} className={s.accordion} {...rest}>
      {children}
    </Accordion>
  );
};

export const FormAccordionItem = (props: AccordionItemProps) => {
  const { children, header, isRequired, ...rest } = props;

  return (
    <AccordionItem
      header={
        <>
          <Text type="brandon" isStrong>
            {header}
          </Text>

          {!isRequired && <ArrowDown className={s.itemArrow} data-testid="accordion-arrow" />}
        </>
      }
      buttonProps={{
        className: ({ isEnter }) => cx(s.itemBtn, isEnter && s.itemBtnExpanded),
      }}
      contentProps={{ className: s.itemContent }}
      panelProps={{ className: s.itemPanel }}
      className={s.item}
      initialEntered={true}
      {...(isRequired ? { disabled: true } : {})}
      {...rest}
    >
      {children}
    </AccordionItem>
  );
};
